import { render, staticRenderFns } from "./TicketDetailDrawer.vue?vue&type=template&id=182d3fee&scoped=true&"
import script from "./TicketDetailDrawer.vue?vue&type=script&lang=js&"
export * from "./TicketDetailDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailDrawer.vue?vue&type=style&index=0&id=182d3fee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d3fee",
  null
  
)

export default component.exports